<template>
  <AppToggleSection>
    <template #title>
      Gestion des onglets visibles
    </template>
    <template #default>
      <form @submit.prevent="fetchStoreCapabilities">
        <b-field label="Adresse email du propriétaire">
          <b-input
            v-model="ownerEmail"
            placeholder="adresse email du propriétaire du compte"
            type="email"
            required
          />
        </b-field>
        <!-- Bouton pour afficher les elements -->
        <div class="buttons is-right">
          <b-button
            v-if="!enterpriseCapabilities"
            class="mt-4"
            type="is-primary"
            @click="fetchStoreCapabilities"
            :loading="isLoading"
          >
            Voir les onglets
          </b-button>
        </div>

        <!-- Affichage des enterprise capabilities -->
        <div v-if="enterpriseCapabilities">
          <b-field label="Sélectionner les onglets à masquer">
            <div class="disable-tab-container">
              <div
                class="field"
                v-for="(value, key) in enterpriseCapabilities"
                :key="key"
              >
                <b-checkbox
                  v-model="enterpriseCapabilities[key]"
                  @input="updateCapability(key)"
                >
                  {{ getCapabilityLabel(key) }}
                </b-checkbox>
              </div>
            </div>
          </b-field>

          <div class="buttons is-right">
            <b-button
              type="is-primary"
              @click="saveEnterpriseCapabilities"
              :disabled="!hasChanges"
              :loading="isSaving"
            >
              Enregistrer les modifications
            </b-button>
          </div>
        </div>
      </form>
    </template>
  </AppToggleSection>
</template>

<script>
import AdminAPI from '@app/services/API/Admin';

export default {
  name: 'DisableTab',

  data() {
    return {
      ownerEmail: '',
      enterpriseCapabilities: null,
      originalCapabilities: null,
      isLoading: false,
      isSaving: false,
    };
  },

  validate() {
    return {
      ownerEmail: {
        required: true,
        email: true,
      },
    };
  },

  computed: {
    hasChanges() {
      if (!this.originalCapabilities || !this.enterpriseCapabilities) return false;

      return Object.keys(this.enterpriseCapabilities).some(
        (key) => this.enterpriseCapabilities[key] !== this.originalCapabilities[key],
      );
    },
  },

  watch: {
    ownerEmail(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onEmailChange();
      }
    },
  },

  methods: {
    onEmailChange() {
      if (this.enterpriseCapabilities) {
        this.enterpriseCapabilities = null;
        this.originalCapabilities = null;
      }
    },

    async fetchStoreCapabilities() {
      this.isLoading = true;
      try {
        const response = await AdminAPI.getStoreEnterpriseCapabilities(this.ownerEmail);
        console.log('Réponse ', response);
        this.enterpriseCapabilities = response.data.enterprise_capabilities;
        this.originalCapabilities = { ...this.enterpriseCapabilities };
      } catch (error) {
        console.error('Erreur lors de la récupération des données :', error);
        this.$buefy.toast.open({
          message: 'Erreur lors de la récupération de la configuration',
          type: 'is-danger',
        });
      } finally {
        this.isLoading = false;
      }
    },

    async saveEnterpriseCapabilities() {
      this.isSaving = true;
      try {
        await AdminAPI.updateStoreEnterpriseCapabilities({
          email: this.ownerEmail,
          enterprise_capabilities: this.enterpriseCapabilities,
        });

        this.$buefy.toast.open({
          message: 'Configuration des onglets mise à jour avec succès',
          type: 'is-success',
        });
      } catch (error) {
        console.error('Erreur lors de la mise à jour:', error);
        this.$buefy.toast.open({
          message: 'Erreur lors de la mise à jour de la configuration',
          type: 'is-danger',
        });
      } finally {
        this.isSaving = false;
        this.ownerEmail = '';
      }
    },

    getCapabilityLabel(key) {
      const labels = {
        hide_copywriter: 'Masquer le copywriter',
        hide_community: 'Masquer la communauté',
        hide_sales: 'Masquer les ventes',
        hide_plan: 'Masquer le plan',
        hide_discounts: 'Masquer les réductions',
        hide_affiliation: 'Masquer l\'affiliation',
      };

      return labels[key] || key.replace('hide_', 'Masquer ').replace(/_/g, ' ');
    },
  },
};
</script>

<style scoped>
.disable-tab-container {
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  padding: 0.5rem;
  max-height: 300px;
  overflow-y: auto;
}
</style>
